// extracted by mini-css-extract-plugin
export default {"page":"error_page_page__1Bp1i"};